import { render, staticRenderFns } from "./StatusBox.vue?vue&type=template&id=0fe25b06&scoped=true&"
import script from "./StatusBox.vue?vue&type=script&lang=ts&"
export * from "./StatusBox.vue?vue&type=script&lang=ts&"
import style0 from "./StatusBox.vue?vue&type=style&index=0&id=0fe25b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe25b06",
  null
  
)

export default component.exports